import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData } from 'src/store/account/actions';
import { getUser, isValidToken } from 'src/utils/auth';

const Auth: FC = ({ children }) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (isValidToken()) {
        await dispatch(setUserData(JSON.parse(getUser()!)));
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default Auth;
